/**
 * 菜单缓存 TTL 工具（阶段：菜单缓存半天过期）。
 *
 * 版本号用「年月日时」YYYYMMDDHH（如 2026082616），从上次写缓存算起，
 * 满 TTL_HOURS 小时即视为过期需重拉。各用户写缓存时间天然错开，分散后端压力。
 *
 * 不改动原菜单树的存储（仍存 lwmsLoginUserSpmMenuTreeNew-*），
 * 只额外维护一个「版本时间戳」伴生 key，判断是否过期。
 */
export const MENU_TTL_HOURS = 12

// 生成当前版本号：年月日时
export function nowMenuVer() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return Number(`${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}${p(d.getHours())}`)
}

// 把 YYYYMMDDHH 版本号解析回时间戳
function verToTime(ver) {
  const s = String(ver)
  if (s.length !== 10) return NaN
  return new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), +s.slice(8, 10)).getTime()
}

// 缓存写入时刻距今多少小时（NaN 表示无有效版本）
export function menuCacheAgeHours(ver) {
  const t = verToTime(ver)
  if (Number.isNaN(t)) return NaN
  return (Date.now() - t) / 3600000
}

function verKey(bizKey) {
  return `${bizKey}__ver`
}

// 写缓存时同时记版本号
export function markMenuCacheVer(bizKey) {
  try {
    window.localStorage.setItem(verKey(bizKey), String(nowMenuVer()))
  } catch (e) {
    console.error('markMenuCacheVer failed:', e)
  }
}

// 判断某菜单缓存是否过期（无版本号视为过期，强制重拉）
export function isMenuCacheExpired(bizKey) {
  const ver = window.localStorage.getItem(verKey(bizKey))
  if (!ver) return true
  const age = menuCacheAgeHours(ver)
  if (Number.isNaN(age)) return true
  return age >= MENU_TTL_HOURS
}
